export default {
    common: {
        hello: 'Hello, {name}!',
        total: 'Total:',
        programTrans:'Program Trans',
        transI18n:'Trans I18n',
        confirm:'Confirm',
        reset:'Reset',
        submit:'Submit',
        info:"Info",
        error:"Error",
        question:"Question",
        warning:"Warning",
        placeholder:"Please Input ",
        selectholder:"Please Select ",
        rowNumber:"Row Number",
        actions:"Actions",
        add:"add",
        delete:"Delete",
        edit:"Edit",
        save:"Save",
        cancle:"Cancle"
    },
    global:{
        setParam:'Set Global Param',
        getParam:'Get Global Param'
    }
}